import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { DocumentFile } from '@app/models';

export const {
  initialState: documentFileInitialState,
  selectors: documentFileSelectors,
  facade: DocumentFileFacadeBase,
} = buildState(DocumentFile);

export function documentFileReducer(
  state = documentFileInitialState
): IEntityState<DocumentFile> {
  return state;
}
